import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

/**
 * A text box control that allows autocomplete.
 * Pass it an array of strings in the options.options to populate the autocomplete list
 */
export class AutoCompleteTextBoxControl extends FormControlBase<string> {
  controlType = 'autocomplete-textbox';

  allowBrowserAutocomplete: boolean = true;

  constructor(options: FormControlData<string> = {}) {
    super(options);
  }

  protected initialize() {
    super.initializeDefault();
  }
}
